module.exports = __webpack_public_path__ + "static/media/engineering.cedd7b96.png";